import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventLineupsCompleted extends DomainEvent<MatchEvent> {}
